import { defineAsyncComponent } from 'vue';

const TablefilterResendEmail = defineAsyncComponent(() => import('./TableFilterResend.vue'));

export default TablefilterResendEmail;